import { ListItemContent, Stack, Typography } from '@healthinal/ui';
import {
  AddressContactDropdownDto,
  getAddressContactsDropdown,
} from '../../../api/created/addressContactDropdown.ts';
import { GenericAutocomplete } from '../GenericAutocomplete.tsx';

interface Props {
  onChange: (contact: AddressContactDropdownDto | null) => void;
  value: AddressContactDropdownDto | null;
  disabled?: boolean;
}

export function SelectAppointmentExecutor({ onChange, value, disabled }: Props) {
  return (
    <GenericAutocomplete<AddressContactDropdownDto>
      value={value}
      onChange={onChange}
      fetchOptions={async ({ search, signal }) => {
        const items = await getAddressContactsDropdown({ search: search || undefined }, undefined, signal);

        return { items, hasMore: false };
      }}
      getOptionLabel={formatAddressContactName}
      getOptionKey={(option) => option.id ?? `${option.addressId ?? ''}-${formatAddressContactName(option)}`}
      getSearchText={(option) =>
        [
          option.firstName,
          option.lastName,
        ]
          .filter(Boolean)
          .join(' ')
      }
      isOptionEqualToValue={(option, selectedValue) => option.id === selectedValue.id}
      renderOptionContent={(option) => (
        <ListItemContent>
          <Stack gap={0.25}>
            <Typography level="title-sm">{formatAddressContactName(option)}</Typography>
          </Stack>
        </ListItemContent>
      )}
      enableSearch
      placeholder="Bitte auswählen"
      disabled={disabled}
      noOptionsText="Keine Kontakte gefunden"
    />
  );
}

export function formatAddressContactName(contact: Pick<AddressContactDropdownDto, 'firstName' | 'lastName'>) {
  return `${contact.lastName ?? ''} ${contact.firstName ?? ''}`.trim();
}
